import * as React from "react";
import {
  Description,
  Headline,
  KudosNumber,
  UserImage,
  UserName,
  Wrapper,
  WrapperUser,
  WrapperUserName,
} from "./topPicksStyled";
import KudosContext from "src/context";

export class TopPicksComponent extends React.Component<{}> {
  public static contextType = KudosContext;
  public context!: React.ContextType<typeof KudosContext>;

  public componentDidMount() {
    this.context!.fetchTopPicks();
  }

  public render() {
    return (
      <Wrapper>
        <Headline>Top picks</Headline>
        <Description>Most kudos last month gathered:</Description>
        {this.renderTopPicks()}
      </Wrapper>
    );
  }

  private renderTopPicks = () => {
    const topPicks = this.context!.topPicks;

    if (!topPicks) {
      return null;
    }

    return topPicks.map((topPick) => {
      return (
        <WrapperUser key={topPick.user.id}>
          <UserImage src={topPick.user.image_url} />
          <WrapperUserName>
            <UserName>{topPick.user.display_name}</UserName>
            <KudosNumber>
              <KudosNumber>{topPick.kudos_count}</KudosNumber> kudos
            </KudosNumber>
          </WrapperUserName>
        </WrapperUser>
      );
    });
  };
}
